import { useContext } from "react";
import { PricesContext } from "./PricesProvider";

export const usePrices = () => useContext(PricesContext);
